import { Helmet } from 'react-helmet';
import Footer from '../../components/light/modern-agency/Footer';
import Lines from '../../components/light/common/Lines';
import ProgressScroll from '../../components/light/common/ProgressScroll';
import Cursor from '../../components/light/common/cusor';
import LoadingScreen from '../../components/light/common/loader';
import SecNavbar from '../../components/light/services-details/SecNavbar';
import Testimonials from '../../components/light/FAQS/Testimonials';
// import Blog from '../../components/light/services/Blog';
import Header from '../../components/light/contact/CareerHeader';
import Services from '../../components/light/services2/Services';
// import MainFeat from '../../components/light/services2/MainFeat';
// import Brands from '../../components/light/services2/Brands';
export default function LPageServices2() {
  return (
    <>
      <Helmet>
        <title>Aashway | Career</title>
        <link rel="icon" href="/light/imgs/favicon.ico" />
        <link rel="shortcut icon" href="/light/imgs/favicon.ico" />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/plugins.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/style.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="/light/assets/css/satoshi.css"
        />

        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css?family=Poppins:100,200,300,400,500,600,700,800,900&display=swap"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght..200;300;400;500;600;700&display=swap"
        />
        <script src="/light/assets/js/scripts.js"></script>
        <script src="/light/assets/js/smoother-script.js"></script>
      </Helmet>
      <body>
        <LoadingScreen />
        <Cursor />
        <ProgressScroll />
        <Lines />
        <div id="smooth-wrapper">
          <SecNavbar />
          <div id="smooth-content">
            <main className="main-bg">
              <Header />
              <Services />
              {/* <MainFeat /> */}
              <Testimonials />
              {/* <Brands /> */}
              {/* <Blog /> */}
            </main>
            <Footer />
          </div>
        </div>
      </body>
    </>
  );
}
